import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'antd/dist/antd.css';
import * as serviceWorker from './serviceWorker';
import Mh_policy from './components/Mh_policy/index';
import PEDUbon_policy from './components/PEDUbon_policy/index';
import Moj_go_th from './components/Survey/Moj_go_th';
import Moj_go_th2 from './components/Survey/Moj_go_th2';
import Moj_go_th3 from './components/Survey/Moj_go_th3';
import Import_data from './components/Data/Import_data';
import Result from './components/Survey/Result';
import Surwey_area from './components/Surwey_area';
import SsrIndex from './components/SurwaySuree/SsrIndex';
import SsrResult from './components/SurwaySuree/SsrResult';
import Sc from './components/SurwayCrop/Sc';
import ScResult from './components/SurwayCrop/ScResult';
import AdminEdit from './components/AdminEdit';
import test from './components/test';



ReactDOM.render(
    <Router>
        <Route exact path='/' component={App} />
        <Route path='/mh_policy' component={Mh_policy} />
        <Route path='/pedubon_policy' component={PEDUbon_policy} />
        <Route path='/import_data' component={Import_data} />
        <Route path='/moj_go_th' component={Moj_go_th} />
        <Route path='/moj_go_th2' component={Moj_go_th2} />
        <Route path='/moj_go_th3' component={Moj_go_th3} />
        <Route path='/result' component={Result} />
        <Route path='/surwey_area' component={Surwey_area} />
        <Route path='/ssr_result' component={SsrResult} />
        <Route path='/ssr' component={SsrIndex} />
        <Route path='/sc' component={Sc} />
        <Route path='/scResult' component={ScResult} />
        <Route path='/adminEdit' component={AdminEdit} />
        <Route path='/test' component={test} />
    </Router>
    , document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
